<pw-view-title *ngIf="pboName">{{ pboName }} bearbeiten</pw-view-title>

<pw-view-actions>
  <button
    *ngIf="selection && selection.hasValue()"
    mat-button
    (click)="openEditDialog()">
    <mat-icon>edit</mat-icon>
  </button>
</pw-view-actions>

<table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
  <ng-container matColumnDef="select">
    <th mat-header-cell *matHeaderCellDef>
      <mat-checkbox
        (change)="$event ? toggleAllRows() : null"
        [checked]="selection.hasValue() && isAllSelected()"
        [indeterminate]="selection.hasValue() && !isAllSelected()">
      </mat-checkbox>
    </th>
    <td mat-cell *matCellDef="let row">
      <mat-checkbox
        (click)="$event.stopPropagation()"
        (change)="$event ? selection.toggle(row) : null"
        [checked]="selection.isSelected(row)">
      </mat-checkbox>
    </td>
  </ng-container>

  <ng-container matColumnDef="pboPosName">
    <th mat-header-cell mat-sort-header *matHeaderCellDef>Position</th>
    <td mat-cell *matCellDef="let element">{{ element.pboPosName }}</td>
  </ng-container>

    <ng-container matColumnDef="bmNr">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>BM-Nummer</th>
        <td mat-cell *matCellDef="let element">{{ element.bmNr }}</td>
    </ng-container>

    <ng-container matColumnDef="pboPosLinkName">
    <th mat-header-cell mat-sort-header *matHeaderCellDef>Prüfmittel</th>
    <td mat-cell *matCellDef="let element">
      {{ element.pboPosLinkName }} {{ element.pboPosLinkDescription }}
    </td>
  </ng-container>

  <ng-container matColumnDef="extPlannerText">
    <th mat-header-cell mat-sort-header *matHeaderCellDef>Externer Planer</th>
    <td mat-cell *matCellDef="let element">{{ element.extPlannerText }}</td>
  </ng-container>

  <ng-container matColumnDef="extMetrologistText">
    <th mat-header-cell mat-sort-header *matHeaderCellDef>
      Externer Messtechniker
    </th>
    <td mat-cell *matCellDef="let element">{{ element.extMetrologistText }}</td>
  </ng-container>

  <ng-container matColumnDef="kickoffDate">
    <th mat-header-cell mat-sort-header *matHeaderCellDef>Kickoff</th>
    <td mat-cell *matCellDef="let element">{{ element.kickoffDate | date }}</td>
  </ng-container>

  <ng-container matColumnDef="acceptanceDate">
    <th mat-header-cell mat-sort-header *matHeaderCellDef>Abnahme</th>
    <td mat-cell *matCellDef="let element">
      {{ element.acceptanceDate | date }}
    </td>
  </ng-container>

  <ng-container matColumnDef="latestReleaseConstDate">
    <th mat-header-cell mat-sort-header *matHeaderCellDef>Konstruktion</th>
    <td mat-cell *matCellDef="let element">
      {{ element.latestReleaseConstDate | date }}
    </td>
  </ng-container>

  <ng-container matColumnDef="latestReleaseSpecDate">
    <th mat-header-cell mat-sort-header *matHeaderCellDef>Spezifikation</th>
    <td mat-cell *matCellDef="let element">
      {{ element.latestReleaseSpecDate | date }}
    </td>
  </ng-container>

  <ng-container matColumnDef="productionProgress">
    <th mat-header-cell mat-sort-header *matHeaderCellDef>
      Fertigungsfortschritt
    </th>
    <td mat-cell *matCellDef="let element">
      <span
        >{{
          element.productionProgress ? element.productionProgress * 100 : 0
        }}%</span
      >
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
